import { useMemo } from 'react';
import { useGetCommonCodeType } from 'src/api/common_code';
import { chooseLan } from 'src/utils/language_code';

export function useCommonCode(codeType) {
  const { searchResults, searchLoading } = useGetCommonCodeType({
    codeType,
    isActive: true,
  });

  const memoizedValue = useMemo(() => {
    if (!searchResults || searchResults.length === 0) {
      return { options: [], rawData: null };
    }

    const codeData = searchResults.find((code) => code.codeType === codeType);
    if (!codeData || !codeData.details) {
      return { options: [], rawData: null };
    }

    const options = codeData.details
      .filter((detail) => detail.isActive)
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .map((detail) => ({
        value: detail.codeValue,
        label: chooseLan(detail.codeValueNameLocal, detail.codeValueNameEnglish),
        displayOrder: detail.displayOrder,
        ...detail,
      }));

    return { options, rawData: codeData };
  }, [searchResults, codeType]);

  return {
    ...memoizedValue,
    loading: searchLoading,
  };
}
